import TumengNumber from './src/index.vue'

TumengNumber.install = function(Vue) {
  Vue.component(TumengNumber.name, TumengNumber)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengNumber)
}

export default TumengNumber
